import { Collab } from '@foodfluence/shared';
import { isUGC } from 'utils/deliverableUtils';

/** UGC collabs: upload photos/videos, then submit live post links. */
export const ugcSubmissionPath = (collabId: string) => `/collabs/content-submission?id=${collabId}`;

/** Social-deliverable collabs: submit drafts and post links per platform slot. */
export const deliverableSubmissionPath = (collabId: string) => `/collabs/complete-collab?id=${collabId}`;

export const submissionPathForCollab = (collab: Collab) =>
  isUGC(collab) ? ugcSubmissionPath(collab.id) : deliverableSubmissionPath(collab.id);
